import React from 'react';
import './LoadingSpinner.scss';

interface LoadingSpinnerProps {
  text?: string;
  transparent?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ text, transparent }) => {
  const finalText = text || 'MedioPunto';
  const containerClass = transparent
    ? 'loading-spinner-container transparent'
    : 'loading-spinner-container normal';

  return (
    <div className={containerClass}>
      <img
        src={`${process.env.PUBLIC_URL}/logos/Recurso 49MEDIOPUNTO.png`}
        alt="MedioPunto Logo"
        className="rotating-image"
      />
      <p className="loading-text">{finalText}</p>
    </div>
  );
};

export default LoadingSpinner;
